import type { ItemState } from '../data/progress.ts';

interface CoverTileProps {
  title: string;
  imageUrl: string;
  onClick: () => void;
  /** 0..1 – zeichnet einen Fortschrittsbalken am unteren Coverrand. */
  fraction?: number;
  /** Ohne Angabe wird kein Statussymbol gezeigt (z. B. bei Gruppen). */
  state?: ItemState;
  size?: 'normal' | 'large';
}

/**
 * Kachel fuer Gruppen und Folgen.
 *
 * Der Zustand wird ausschliesslich ueber Bild und Symbol vermittelt, nie ueber
 * Text – die Zielgruppe kann nicht lesen.
 */
export function CoverTile({
  title,
  imageUrl,
  onClick,
  fraction = 0,
  state,
  size = 'normal',
}: CoverTileProps) {
  const showProgress = state === 'inProgress' && fraction > 0;

  return (
    <button
      type="button"
      className={`tile tile--${size}${state ? ` tile--${state}` : ''}`}
      onClick={onClick}
      aria-label={title}
    >
      <span className="tile__art">
        {imageUrl ? (
          <img src={imageUrl} alt="" draggable={false} />
        ) : (
          <span className="tile__placeholder" aria-hidden="true">
            ♪
          </span>
        )}

        {/* Balken statt Ring: ein Ring ueber dem Cover verdeckt genau das Motiv,
            an dem das Kind die Folge erkennt. */}
        {showProgress && (
          <span className="tile__progress" aria-hidden="true">
            <span
              className="tile__progress-value"
              style={{ width: `${Math.min(1, fraction) * 100}%` }}
            />
          </span>
        )}

        {/* Symbole bewusst als weisse Kreise mit dunklem Rand: Hoerspiel-Cover
            sind farblich sehr unruhig, farbige Symbole gehen darin unter. */}
        {state === 'finished' && (
          <span className="tile__badge tile__badge--done" aria-hidden="true">
            ✓
          </span>
        )}
        {state === 'new' && (
          <span className="tile__badge tile__badge--new" aria-hidden="true">
            🎁
          </span>
        )}
        {state === 'inProgress' && (
          <span className="tile__badge tile__badge--resume" aria-hidden="true">
            ▶
          </span>
        )}
      </span>
      <span className="tile__title">{title}</span>
    </button>
  );
}
